export const getWinPercentage = (totalFactorsSum, currentFactor) => {
    return Math.round((currentFactor / totalFactorsSum) * 100)
}
